import { z } from "zod";

export const Step1Schema = z.object({
  country: z.enum(["GB", "PT", "BR"]),
  companyName: z.string().min(1, "onboarding.validation.companyNameRequired"),
  fleetSize: z.enum(["1-5", "5-20", "20-50", ">50"]).optional(),
});

export type Step1Input = z.infer<typeof Step1Schema>;
